export enum MsTeamsThemes {
  DEFAULT = 'default',
  DARK = 'dark',
  CONTRAST = 'contrast',
}
